import {
  xlsxCellSerial,
  createXlsxColumn,
  createXlsxCellStyle,
  createColumnWidth,
  createColumnHeight,
  createColumnMerge,
} from "../../../../service/excel";
import moment from "moment";

export const createXlsxDetail = ({
  title,
  data: { workbook, reportType, reportData, optionData },
}) => {
  const ws = workbook.addWorksheet(title);

  let ws_detail = createScope(ws, reportType, reportData, optionData);

  createColumnWidth({
    ws,
    columns: [
      { column: "A", width: 25 },
      { column: "B", width: 18 },
      ...optionData.question[reportType].map((item, index) => ({
        column: xlsxCellSerial[2 + index],
        width: 15,
      })),
    ],
  });

  createColumnHeight({
    ws,
    columns: [{ column: 1, height: 24 }],
  });

  createColumnMerge({
    ws,
    columns: [...ws_detail.merges],
  });
};

const createScope = (ws, reportType, reportData, optionData) => {
  let merges = [];
  let head = {
    // 基本資料
    member: [
      { label: "帳號", key: "username" },
      { label: "日期", key: "date" },
    ],
    // 問卷
    question: [
      ...optionData.question[reportType].map((item, index) => ({
        ...item,
        label: item.title,
      })),
    ],
  };

  reportData.forEach((rowData, rIdx) => {
    head.member.forEach((member, mIdx) => {
      if (rIdx === 0) {
        createXlsxColumn({
          ws,
          column: `${xlsxCellSerial[mIdx]}1`,
          value: member.label,
          styles: createXlsxCellStyle({
            font_bold: true,
            fill_color: "f2f2f2",
            wrapText: false,
          }),
        });
      }

      let value = rowData.member?.[member.key];
      createXlsxColumn({
        ws,
        column: `${xlsxCellSerial[mIdx]}${2 + rIdx}`,
        value,
        styles: createXlsxCellStyle({
          wrapText: false,
        }),
      });
    });

    head.question.forEach((question, mIdx) => {
      if (rIdx === 0) {
        createXlsxColumn({
          ws,
          column: `${xlsxCellSerial[head.member.length + mIdx]}1`,
          value: question.label,
          styles: createXlsxCellStyle({
            font_bold: true,
            fill_color: "f2f2f2",
            wrapText: false,
          }),
        });
      }

      let value = rowData.question?.[question.key];
      createXlsxColumn({
        ws,
        column: `${xlsxCellSerial[head.member.length + mIdx]}${2 + rIdx}`,
        value: optionData[`level_${reportType}_obj`][value]?.showLabel,
        styles: createXlsxCellStyle({
          wrapText: false,
        }),
      });
    });
  });

  return {
    merges: [...merges],
  };
};
